<template>
  <div class="gansu">
    <div class="contentGansu">
      <div class="right">
<!--        <div class="title">
          <img class="logo" src="../assets/aboutUs/logo.png" alt="">
        </div>
        <div class="info">丝绸之路知识产权港版权综合服务中心是经省委宣传部批准，省版权局授权，依托丝绸之路国际知识产权港有限责任公司设立的版权登记综合服务机构。中心主要负责全省版权登记受理、初审工作，以及开展版权投资孵化、运营交易、维权保护等全链条服务，为实现版权资产管理与运营服务的产业化升级创造更大的市场价值。</div>
        <div class="mapBox">
          <div class="titleM">
            <img class="dian" src="../assets/aboutUs/dian.png" alt="">
            <div class="text">联系信息</div>
          </div>
          <div class="item">联系电话：0931-8270727</div>
          <div class="item">在线QQ客服：1767391602</div>
          <div class="item">联系地址：甘肃省兰州市城关区雁南路279号科庆综合楼10楼</div>
          <div class="map" style="width:100%;height:330px;" id="myMap"></div>
        </div>-->

        <div class="aboutUs">
          <div class="banner" style="height: 215px">
            <div style="width:1200px;margin: 0 auto">
            <div style="display: flex; justifyContent: center; alignItems: center;">
              <div style="width: 330px; height: 2px; background: #eee;"></div>
              <p class="p_top" style="margin: 65px 30px; height: auto">
                <img style="width: 480px; height: 60px" src= "../assets/aboutUs/fdsg3.png"/>
              </p>
              <div style="width: 330px; height: 2px; background: #eee;"></div>
            </div>
          </div>
        </div>
        <div class="about_bqjnews" style="marginBottom: 150px">
          <div class="about_bqjnews_content">
            <div style="display: flex; flexDirection: column; justifyContent: flex-start;">
              <div class="about_bqjnews_title" style="height: auto">组织简介</div>
              <div class='about_bqjnews_newFonr'>
                  2019年9月中宣部国家版权局批复在深圳前海设立国家版权创新发展基地，要求以习总书记新时代中国特色社会主义思想为指引，发挥先行示范区优势，抓住粤港澳大湾区建设重要机遇,推进版权产业机制创新、版权产业技术与标准创新、版权运营与服务模式创新 。
                  2021年9月6日中共中央国务院印发的《全面深化前海深港现代服务业合作区改革开放方案》中明确提出要“建设国家版权创新发展基地”。
                  2021年12月29日，中宣部国家版权局印发的《版权工作“十四五”规划》中明确提出要“强化国家版权创新发展基地建设”。
                  <img style="display: block; margin: 0 auto;" src="../assets/aboutUs/hongtouwenjian.png">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;深圳市前海智慧版权创新发展研究院是在前海深港现代服务业合作区管理局指导下，由深圳市前海服务集团有限公司、安妮股份、香港知识产权交易所、
                  北京国际版权交易中心、来画视频等16家企业和机构共同发起成立的，基于版权产业发展研究的专业型非营利社会组织，致力于推动前海“国家版权创新发展基地”建设。
                  <img style="display: block; margin: 0 auto;" src="../assets/aboutUs/hongtouwenjian2.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

  </div>
</template>
<script>
    export default {
      name: "ganan_gansu",
      data(){
        return {

        }
      },
			components: {
			},
      mounted() {
        this.getMap()
      },
      methods: {
        getMap(){
          let map = new BMap.Map("myMap");          // 创建地图实例
          // 116.336088,40.057519 116.506027,39.90859 116.336079,40.057554  116.336009,40.057029
          var point = new BMap.Point(103.901992, 36.058102);  // 创建点坐标  117.943155,24.584984
          map.centerAndZoom(point, 19);
          map.enableScrollWheelZoom(true);
          let marker = new BMap.Marker(point);        // 创建标注
          map.addOverlay(marker);
          let opts = {
            width : 250,     // 信息窗口宽度
            height: 120,     // 信息窗口高度
            title : "前海版权服务中心"  // 信息窗口标题
          }
          let infoWindow = new BMap.InfoWindow("<p style='font-size:16px'></p>", opts);  // 创建信息窗口对象
          map.openInfoWindow(infoWindow, map.getCenter());      // 打开信息窗口
          marker.addEventListener("click",function(){
            marker.openInfoWindow(infoWindow, map.getCenter())
          })
          // 添加定位控件
          let geolocationControl = new BMap.GeolocationControl({
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
            offset: new BMap.Size(20, 20)
          })
          geolocationControl.addEventListener("locationSuccess", function(e){
            map.panTo(new BMap.Point(103.901992, 36.058102));
          });
          geolocationControl.addEventListener("locationError",function(e){
            map.panTo(new BMap.Point(103.901992, 36.058102));
          });
          map.addControl(geolocationControl);
        }
      },
			watch: {
				$route(to, from) {

				}
			}
    };
</script>

<style lang="less" scoped>
.contentGansu{
  .right{
    .title{
      .logo{
        width: 248px;
      }
    }
    .info{
      font-size: 14px;
      line-height: 16px;
      margin: 30px 0 36px 0;
    }
    .mapBox{
      .titleM{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 15px;
        .dian{
          width: 24px;
          margin-right: 8px;
        }
        .text{
          font-family: AlibabaPuHuiTi;
        }
      }
      .item{
        font-size: 14px;
        margin-bottom: 10px;
      }
      .map{
        margin-top: 35px;
      }
    }
  }
}

.aboutUs{
  height: 100%;
  width: 100%;
  background: #fff;
  & .banner{
    height: 982px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    text-align: center;
    overflow: hidden;
    & .p_top{
      height:30px;
      font-size:30px;
      font-weight:bold;
      color:rgba(49,50,54,1);
      line-height:30px;
      margin:119px 0 117px;
    }
    & .p_bottom{
      height:115px;
      font-size:30px;
      margin-top:192px;
      font-weight:bold;
      color:rgba(49,50,54,1);
      line-height:45px;
    }
    & .about_bqj{
      height: 405px;
      display:flex;
      justify-content: space-between;
    }
    & .p_title{
      width:596px;
      height:340px;
      font-size:22px;
      font-weight:400;
      color:rgba(49,50,54,1);
      line-height:34px;
      text-align:left;
      p{
        text-indent: 50px;
      }
    }
  }
  & .about_list{
    height:765px;
    background:rgba(255,255,255,1);
    & ul{
      width: 1200px;
      margin: 0 auto;
      margin-top: 25px;
      display:flex;
      justify-content: space-between;
      & li{
        width:370px;
        height: 310px;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:hover {
          width:370px;
          height:310px;
          background:rgba(255,255,255,1);
          box-shadow:0px 4px 24px 0px rgba(0,0,0,0.05);
          border-radius:5px;
          transform:translateY(-15px);/**上移元素**/
          -ms-transform:translateY(-15px);
          -webkit-transform:translateY(-15px);
        }
        & img{
          width:64px;
          height:64px;
          margin-top:71px;
        }
        & :nth-child(2){
          height:20px;
          font-size:20px;
          font-weight:bold;
          color:rgba(38,48,53,1);
          line-height:20px;
          margin-top:27px;
          margin-bottom:39px;
        }
        & p{
          width:320px;
          height:56px;
          font-size:16px;
          font-weight:500;
          color:rgba(124,125,141,1);
          line-height:28px;
          text-align: center;
        }
      }
    }
  }
}

.newFonr{
  text-indent: 35px;
  text-align: left;
  margin-right: 40px;
  line-height: 30px;
  font-size: 20px;
  margin-top: 30px;
}
.about_bqjnews{
  width:100%;
  height:1800px;
  margin-bottom:50px;
  & .about_bqjnews_content{
    width: 1200px;
    margin: 0 auto;
    & .about_bqjnews_title{
      font-size: 35px;
      font-weight: bold;
      color: #000;
      margin-left: 30px;
      margin-top: 40px;
    }
    & .about_bqjnews_newFonr{
      margin-top: 102px;
      margin-left: 31px;
      margin-right: 100px;
      font-size: 21px;
      color: #000;
      line-height: 50px;
      font-weight: bold;
      text-indent: 50px;
    }
  }
}
</style>
